import React from "react";
import "../csscontainer/Footer.css";
import "../App.css";
import { motion } from "framer-motion";
import Footer from "../components/Footer";
import Text from "../components/Text";
import { TEXT } from "../utility/constants";
import diverseServicesImage from "../assets/images/FieldDispatch.png"; // ASSUMPTION: Update the path to your provided image
import desktop from "../assets/images/desktopLevel.png"; // ASSUMPTION: Update the path to your provided image
import datacenter from "../assets/images/datacenterlayer.png"; // ASSUMPTION: Update the path to your provided image
import network from "../assets/images/networkLayer.png"; // ASSUMPTION: Update the path to your provided image

function FieldDispatch() {
   return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="home-wrapper">
        {/* --- NEW SECTION FOR IMAGE ON RIGHT AND TEXT ON LEFT --- */}
        <div className="service-intro-section">
          <div className="service-intro-text">
            <Text
              color="black"
              size="32px"
              weight="bold"
              align="start"
              style={{ marginBottom: "15px" }}
            >
              {TEXT.FieldHeading}
            </Text>
            <Text
              color="black"
              size="22px"
              weight="bold"
              align="start"
              style={{ marginBottom: "15px" }}
            >
              {TEXT.FieldSubHeading}
            </Text>
            <Text
              color="#364040FF"
              size="18px"
              weight="normal"
              align="start"
              style={{ lineHeight: "1.6" }}
            >
              {TEXT.FieldDescription}
            </Text>
           
          </div>
          <div className="service-intro-image">
            <img
              src={diverseServicesImage} // Your IT service image
              alt="Diverse IT Service Projects and Solutions"
              className="responsive-service-image"
            />
          </div>
        </div>
       
        <div className="service-intro-section">
             <div className="service-intro-image">
            <img
              src={desktop} // Your IT service image
              alt="Diverse IT Service Projects and Solutions"
              className="responsive-service-image"
            />
          </div>
          <div className="service-intro-text">
            <Text
              color="black"
              size="32px"
              weight="bold"
              align="start"
              style={{ marginBottom: "15px" }}
            >
              {TEXT.DesktopHeading}
            </Text>
            <Text
              color="black"
              size="20px"
              weight="normal"
              align="start"
              style={{ marginBottom: "15px" }}
            >
              {TEXT.DesktopSubHeading}
            </Text>
            <Text
              color="black"
              size="18px"
              weight="normal"
              align="start"
              style={{ lineHeight: "1.6" }}
            >
              {TEXT.DesktopDescription}
            </Text>
           <Text
              color="black"
              size="20px"
              weight="normal"
              align="start"
              style={{ marginBottom: "15px",marginTop: "15px" }}
            >
              {TEXT.DesktopDescription2}
            </Text>
          </div>
         
        </div>

        <div className="service-intro-section">
          <div className="service-intro-text">
            <Text
              color="black"
              size="32px"
              weight="bold"
              align="start"
              style={{ marginBottom: "15px" }}
            >
              {TEXT.DataCenterHeading}
            </Text>
            <Text
              color="black"
              size="22px"
              weight="bold"
              align="start"
              style={{ marginBottom: "15px" }}
            >
              {TEXT.DataCenterSubHeading}
            </Text>
            <Text
              color="#364040FF"
              size="18px"
              weight="normal"
              align="start"
              style={{ lineHeight: "1.6" }}
            >
              {TEXT.DataCenterDescription}
            </Text>
            <Text
              color="#364040FF"
              size="18px"
              weight="normal"
              align="start"
              style={{ lineHeight: "1.6" }}
            >
              {TEXT.DataCenterDescription2}
            </Text>
           
          </div>
          <div className="service-intro-image">
            <img
              src={datacenter} // Your IT service image
              alt="Diverse IT Service Projects and Solutions"
              className="responsive-service-image"
            />
          </div>
        </div>

         <div className="service-intro-section">
             <div className="service-intro-image">
            <img
              src={network} // Your IT service image
              alt="Diverse IT Service Projects and Solutions"
              className="responsive-service-image"
            />
          </div>
          <div className="service-intro-text">
            <Text
              color="black"
              size="32px"
              weight="bold"
              align="start"
              style={{ marginBottom: "15px" }}
            >
              {TEXT.NetworkLayoutHeading}
            </Text>
            <Text
              color="black"
              size="20px"
              weight="normal"
              align="start"
              style={{ marginBottom: "15px" }}
            >
              {TEXT.NetworkLayoutSubHeading}
            </Text>
            <Text
              color="black"
              size="18px"
              weight="normal"
              align="start"
              style={{ lineHeight: "1.6" }}
            >
              {TEXT.NetworkLayoutDescription}
            </Text>
           <Text
              color="black"
              size="20px"
              weight="normal"
              align="start"
              style={{ marginBottom: "15px",marginTop: "15px" }}
            >
              {TEXT.NetworkLayoutDescription2}
            </Text>
          </div>
         
        </div>
        <Footer />
      </div>
    </motion.div>);
}
export default FieldDispatch;